/* @flow weak */
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import React from 'react';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';

const GroupName = ({ group }) => {
  const groupName = group.getName();
  const entities = TextEntities.parseEmoji(groupName);
  return <TextWithEntities text={groupName} entities={entities} />;
};

GroupName.propTypes = {
  group: React.PropTypes.oneOfType([
    React.PropTypes.instanceOf(Group),
    React.PropTypes.instanceOf(Organization),
  ]),
};

export default GroupName;



// WEBPACK FOOTER //
// ./src/groups/components/GroupName.jsx